import { render } from "./BehalfRegistration.vue?vue&type=template&id=7be51a57&scoped=true"
import script from "./BehalfRegistration.vue?vue&type=script&lang=js"
export * from "./BehalfRegistration.vue?vue&type=script&lang=js"

import "./BehalfRegistration.vue?vue&type=style&index=0&id=7be51a57&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be51a57"]])

export default __exports__